import { axInstBasic } from "../../../components/Service/Service";
export const fetchcomplaintlt18Data = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintltData`,{searchData}
    );
    
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchcomplaintlt24Data = async (searchData) => {
  // console.log("Search Data", searchData);
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintlt24hrsData`, {searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const complaintDataTat = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintDataTat`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Workshop complaints
export const fetchComplaintltDataCAC = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintltDataCAC`,
      {searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchcomplaintlt24hrsDataCAC = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintlt24hrsDataCAC`,
      {searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchComplaintDataTatCACC = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintDataTatCAC`,
      {searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchComplaintQuarterlyDataCac = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintQuarterlyCAC`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// CSR/////

// BarGraph
export const fetchComplaintQuarterlyCSR = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintQuarterlyCSR`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Linechart

//1st
export const fetchComplaintDataTatCSR = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintDataTatCSR`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 2nd

export const fetchComplaintltDataCSR = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintltDataCSR`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 3rd

export const fetchComplaintlt24hrsDataCSR = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintlt24hrsDataCSR`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


/////New Bar Graph API ////

export const fetchComplaintQuarterlyTotalComplaints = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintQuarterlyNew`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchcomplaintQuarterlyCACNew = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintQuarterlyCACNew`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchComplaintQuarterlyCSRNew = async (searchData) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}complaintQuarterlyCSRNew`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

